import { timeZoneOptions } from 'src/constants/timezone';
import { CUSTOM_VIEW_GROUPS } from 'src/graphql/entities/custom-view/constants';
import {
  CustomViewFormConditionCustomData,
  CustomViewFormConditionField,
  UIType,
} from 'src/graphql/entities/custom-view/custom-view.types';
import { UserGroupRules } from 'src/graphql/entities/group-rules/group-rules.types';
import { ConditionInput, EntityNames } from 'src/graphql/types';
import { SupportedActionQueries } from 'src/pages/Settings/rules/use-rules-engine';
import { ClientAttribute, ClientAttributeAccessors, ClientAttributeType } from './constants';
import { clientAttributeConfigMap } from './displaying';

export const clientFilterAttributesList = [
  {
    attribute: ClientAttribute.partner,
    attributeLabel: 'Partner',
    pluralLabel: 'partners',
    uiType: UIType.List,
    group: CUSTOM_VIEW_GROUPS.Partner,
    optionsQuery: SupportedActionQueries.getPartner,
  },
  {
    ...clientAttributeConfigMap.get(ClientAttribute.timeZone)!,
    uiType: UIType.List,
    options: timeZoneOptions,
    fieldOptions: timeZoneOptions,
  },
  clientAttributeConfigMap.get(ClientAttribute.name)!,
  clientAttributeConfigMap.get(ClientAttribute.email)!,
  {
    ...clientAttributeConfigMap.get(ClientAttribute.marketingOptOut)!,
    uiType: UIType.List,
    optionsQuery: SupportedActionQueries.getBooleanOptions,
  },
  clientAttributeConfigMap.get(ClientAttribute.id)!,
  clientAttributeConfigMap.get(ClientAttribute.createdAt)!,
  clientAttributeConfigMap.get(ClientAttribute.updatedAt)!,
  {
    attribute: ClientAttribute.deleted,
    attributeLabel: 'Deleted',
    uiType: UIType.Flag,
    group: CUSTOM_VIEW_GROUPS.Client,
    allowedRules: [UserGroupRules.AccessToRestoreClients],
    queryParams: { includeDeleted: true },
  },
].map((i) => ({
  options: [],
  fieldOptions: [],
  ...i,
  accessor: ClientAttributeAccessors[i.attribute].filter,
  value: i.attribute,
  label: i.attributeLabel,
  rootEntity: EntityNames.Client as const,
}));

export const clientFilterAttributesMap = new Map<
  ClientAttributeType,
  CustomViewFormConditionField
>(clientFilterAttributesList.map((i) => [i.attribute, i]));

export const CLIENT_CUSTOM_FILTER_MAPPER: Record<
  string,
  (data: CustomViewFormConditionCustomData) => ConditionInput | ConditionInput[]
> = {
  [ClientAttribute.name]: (data: CustomViewFormConditionCustomData) => {
    const [firstName, lastName] = String(data.value).split(' ');

    if (!lastName && !firstName) {
      return [];
    }

    if ((firstName && !lastName) || (!firstName && lastName)) {
      return [
        {
          attribute: 'firstName',
          value: data.value,
          operator: data.operator,
          logicalOperator: 'or',
        },
        {
          attribute: 'lastName',
          value: data.value,
          operator: data.operator,
          logicalOperator: 'or',
        },
      ];
    }

    return [
      {
        attribute: 'firstName',
        value: firstName,
        operator: data.operator,
        logicalOperator: 'and',
      },
      {
        attribute: 'lastName',
        value: lastName,
        operator: data.operator,
        logicalOperator: 'and',
      },
    ];
  },
};
